import { ProjectSubfolder } from '@/features/iata-binder/ProjectSubfolder/ProjectSubfolder';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const subfolderSearchSchema = z.object({
    type: z.string(),
});

export const Route = createFileRoute(
    '/iata-binder/projects/$projectId/folders/$folderLetter/subfolder/',
)({
    component: ProjectSubfolder,
    validateSearch: subfolderSearchSchema,
});
